import { Apis } from "libs/apis";
import { dispatch } from "store";
import { setModalClosed } from "store/user-slice";
import { SessionAmountDTO } from "utils/helpers/models/sessionAmount.dto";

export const useSettings = () => {
    const getSessionCharges = async (setData: any) => {
        await Apis.getSessionCharges()
            .then((res) => {
                console.log(res);
                
                setData(res.data.data);
            })
            .catch((error) => console.error(error));
    };

    const postSessionCharges = async (body: any) => {
        await Apis.postSessionCharges(body)
            .then((res) => {
                // setData(res.data.sessionAmount);
            })
            .catch((error) => console.error(error));
    };


    return {
        getSessionCharges,
        postSessionCharges
    };
};
